export const normalizeText = (text: string) => {
  if (text) {
    return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  } else {
    return "";
  }
};
